import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AdfiService } from '@services/adfi-service';
import { AdfiGraphqlService } from '@services/adfi-graphql.service';
import { SelectItemComponent } from '@Components/ui/select-item/select-item.component';
import {PeriodState} from '@Interfaces/index';

@Component({
  selector: 'app-third-by-town',
  templateUrl: './third-by-town.component.html',
})
export class ThirdByTownComponent implements OnInit {

  periods: any[];
  monthly = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ];
  bimonthly = [
    'Enero - Febrero',
    'Marzo - Abril',
    'Mayo - Junio',
    'Julio - Agosto',
    'Septiembre - Octubre',
    'Noviembre - Diciembre',
  ];
  quaterly = [
    'Enero - Abril',
    'Mayo - Agosto',
    'Septiembre - Diciembre',
  ];
    townsIv: any[] = [  
    {code:'01', town:'Armenia'},  
    {code:'02', town:'Barranquilla'},  
    {code:'03', town:'Bogotá'},  
    {code:'04', town:'Bucaramanga'},  
    {code:'05', town:'Cali'},  
    {code:'06', town:'Cartagena'},  
    {code:'07', town:'Cúcuta'},  
    {code:'08', town:'Girardot'},  
    {code:'09', town:'Ibagué'},  
    {code:'10', town:'Manizales'},  
    {code:'11', town:'Medellín'},  
    {code:'12', town:'Montería'},  
    {code:'13', town:'Neiva'},  
    {code:'14', town:'Pasto'},  
    {code:'15', town:'Palmira'},  
    {code:'16', town:'Pereira'},  
    {code:'17', town:'Popayán'},  
    {code:'18', town:'Quibdó'},  
    {code:'19', town:'Santa Marta'},  
    {code:'20', town:'Tunja'},  
    {code:'21', town:'Túlua'},  
    {code:'22', town:'Villavicencio'},  
    {code:'23', town:'Sincelejo'},  
    {code:'24', town:'Valledupar'},  
    {code:'25', town:'Riohacha'},  
    {code:'26', town:'Sogamoso'},  
    {code:'27', town:'San Andrés'},  
    {code:'28', town:'Florencia'},  
    {code:'29', town:'Barrancabermeja'},  
    {code:'31', town:'Grandes Contribuyentes'},  
    {code:'32', town:'Bogotá'},  
    {code:'34', town:'Arauca'},  
    {code:'35', town:'Buenaventura'},  
    {code:'36', town:'Cartago'},  
    {code:'37', town:'Ipiales'},  
    {code:'38', town:'Leticia'},  
    {code:'39', town:'Maicao'},  
    {code:'40', town:'Tumaco'},  
    {code:'41', town:'Urabá'},  
    {code:'42', town:'Puerto Carreño'},  
    {code:'43', town:'Inírida'},  
    {code:'44', town:'Yopal'},  
    {code:'45', town:'Mitú'},  
    {code:'46', town:'Puerto Asís'},  
    {code:'48', town:'Cartagena'},   
    {code:'78', town:'San José de Guaviare'},    
    {code:'86', town:'Pamplona'},  
    {code:'87', town:'Barranquilla'},  
    {code:'88', town:'Cali'},  
    {code:'89', town:'Cúcuta'},  
    {code:'90', town:'Medellín'}
  ];

  towns: any[] = [];
  sections: any[] = [];
  isLoadingMunicipalities: boolean = false; 
  currentPeriod: number;
  label: string | null = null;
  third: number;
  type: string;
  range: string;
  dates: string;
  town: string;
  fieldLabel: string = 'Municipio';
  help = '';
  block = false;

   isLoadingOptions(): boolean {
    const loading = this.isICAType() && this.isLoadingMunicipalities;
    return loading;
  }

  constructor(
    private service: AdfiService,
    private graphqlService: AdfiGraphqlService,
    public dialog: MatDialog,
  ) {this.sections = []; }

  ngOnInit() {
    this.periods = this.service.periods.filter(period => period.year >= 2024);
    this.loadMunicipalities();  
    this.loadSections(); 
    this.block = this.service.validPermission('BlockingPlatform', 'lock', PeriodState.NO_STATUS);  
  }

  loadSections() {
    this.sections = this.townsIv;
  }

  loadMunicipalities() {
    this.isLoadingMunicipalities = true;
    
    this.graphqlService.getMunicipalitiesForSelect({
      next: (municipalities) => {

        this.towns = municipalities || [];
        this.isLoadingMunicipalities = false;

      },
      error: (error) => {

        this.isLoadingMunicipalities = false;
        this.towns = []; 

      }
    });
  }

  onTypeChange() {
    this.updateFieldConfig();
    this.town = null; 
    
    if (this.isICAType()) {
      this.loadMunicipalities();
    }
  }

  isICAType(): boolean {
    const isICA = this.type === 'RC';
    return isICA;
  }

  updateFieldConfig() {
    if (this.isICAType()) {
      this.fieldLabel = 'Municipio';
      this.help = 'Seleccione el municipio donde se realiza la retención ICA';
    } else {
      this.fieldLabel = 'Seccional';
      this.help = 'Recuerde verificar la seccional de la DIAN a la que está inscrita la institución educativa. Esta información se encuentra en la casilla 12 del RUT institucional.';
    }
  }

  getCurrentOptions(): any[] {
    const options = this.isICAType() ? this.towns : this.sections;
    return options;
  }

  selectItem() {
    let dialogRef: MatDialogRef<any>;
    const data = {
      module: "Adjustments",
      entityName: "ThirdByTown",
      action: "select",
      enableAdd: false,
      displayGroup: 'TE',
      defaultFilters: [
        {
          column: "codTown",
          value: "centroCosto_coCentroCosto",
          filter: "userPropertyFilter"
        }
      ],
      customTitle: 'Seleccionar Terceros'
    };

    dialogRef = this.dialog.open(SelectItemComponent, {
      data,
      width: "80%",
      maxHeight: "70vh",
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.third = result._id;
      this.label = `${result.nit} - ${result.names} ${result.firstSurname || ''}`;
    });
  }

  removeItem() {
    this.label = null;
    this.currentPeriod = null;
    this.town = null;
    this.type = null;
    this.range = null;
    this.dates = null;
    this.fieldLabel = 'Seccional';
  }

  clear() {
    this.currentPeriod = null;
    this.town = null;
    this.range = null;
    this.dates = null;
  }


  getAllFilters() {
    return {
      third: this.third,
      type: this.type,
      period: this.currentPeriod,
      town: this.town,
      dates: this.range === 'A'? 'A': this.dates
    };
  }

  download() {
    this.service.download(
      'Adjustments\\ThirdByTown',
      JSON.stringify(this.getAllFilters()),
      'fileName',
      `application/pdf`,
      `Certificado de Retención.pdf`,
      undefined,
      null
    );
  }

}
